import script from "./SnapshotLayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SnapshotLayer.vue?vue&type=script&setup=true&lang=ts"

import "./SnapshotLayer.vue?vue&type=style&index=0&id=3250881e&lang=less&scoped=true"

import exportComponent from "/Users/ivan/Codes/ripple/wfj-vto-hub/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3250881e"]])

export default __exports__